import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Typography,
  useTheme,
  Grid,
  Box,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import useDivesiteStats from "../../hooks/useDives";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import { styled } from "@mui/material/styles";

const StyledCard = styled(Card)(({ theme }) => ({
  textAlign: "center",
  width: "100%",
  maxWidth: 200,
  flex: 1,
}));

const DivesLogged = ({ divesiteId }) => {
  const {
    statsWithComments,
    loading: statsLoading,
    error: statsError,
  } = useDivesiteStats(divesiteId);

  const [userDivesAtSite, setUserDivesAtSite] = useState([]);
  const { userObjectId, currentUser } = useAuth();
  const [loadingUserDives, setLoadingUserDives] = useState(false);
  const [errorUserDives, setErrorUserDives] = useState(null);
  const userHasDives = userDivesAtSite.length > 0;
  const totalDivesAtSite = statsWithComments?.totalDives || 0;
  const theme = useTheme();

  useEffect(() => {
    const fetchUserDivesAtSite = async () => {
      if (userObjectId && divesiteId) {
        setLoadingUserDives(true);
        setErrorUserDives(null);
        try {
          const token = await currentUser.getIdToken();
          const response = await axios.get(
            `/api/dives/user/${userObjectId}/divesite/${divesiteId}`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserDivesAtSite(response.data);
        } catch (error) {
          console.error("Error fetching user dives at this site:", error);
          setErrorUserDives(error);
        } finally {
          setLoadingUserDives(false);
        }
      } else {
        setUserDivesAtSite([]);
      }
    };

    fetchUserDivesAtSite();
  }, [userObjectId, divesiteId, currentUser]);

  return (
    <StyledCard elevation={3}>
      <CardContent>
        <Grid container spacing={1}>
         
          
          <Grid item xs={12}>
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
    <Typography 
      variant="body2" 
      sx={{ 
        fontWeight: 500, 
        color: 'text.primary',
      }}
    >
      Your Dives Logged:
    </Typography>
    <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: "bold",
                    color: 'primary.main'
                  }}
                >
      {loadingUserDives ? "Loading..." : userHasDives ? userDivesAtSite.length : "None"}
    </Typography>
  </Box>
</Grid>
          
          <Grid item xs={12} sx={{ mt: 1 }}>
  <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
    <Typography 
      variant="body2" 
      sx={{ 
        fontWeight: 500, 
        color: 'text.primary',
      }}
    >
      Total Dives Logged at this Site:
    </Typography>
    <Typography 
                  variant="h5" 
                  sx={{ 
                    fontWeight: "bold",
                    color: 'primary.main'
                  }}
                >
      {statsLoading ? "Loading..." : totalDivesAtSite > 0 ? totalDivesAtSite : "None"}
    </Typography>
  </Box>
</Grid>

        </Grid>
      </CardContent>
    </StyledCard>
  );
};

export default DivesLogged;
